
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wxgazidevakcnkrngykk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind4Z2F6aWRldmFrY25rcm5neWtrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1OTMxNTksImV4cCI6MjA2MjE2OTE1OX0.kEwhzh8H-rTYo3GiY03nf-Phk8BwuSfjaKoumqVslgs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      storage: localStorage,
      storageKey: 'sb-wxgazidevakcnkrngykk-auth-token',
    }
  }
);

// Debug session and token for development
export const debugAuthState = () => {
  const token = localStorage.getItem('sb-wxgazidevakcnkrngykk-auth-token');
  console.log('Current auth token exists:', !!token);
  if (token) {
    try {
      const parsed = JSON.parse(token);
      console.log('Token expiry:', new Date(parsed.expires_at * 1000).toISOString());
      console.log('Token valid:', parsed.expires_at * 1000 > Date.now());
    } catch (e) {
      console.error('Failed to parse token:', e);
    }
  }
};

// Helper to check if a string is a valid UUID
export const isValidUUID = (id: string) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
};

// Helper to create a sample certificate for the current user
export const createSampleCertificate = async (userId: string, userName: string) => {
  try {
    const certificateNumber = `CERT-2025-${Math.floor(Math.random() * 100000)}`;
    const verificationHash = `cb78ff1dc763b6917c5221070700a692d5fe84312a63ed99995a36a0a5c790d4`;
    
    const { data, error } = await supabase
      .from('certificates')
      .insert({
        user_id: userId,
        course_id: 'react-101',
        course_title: 'React Fundamentals',
        certificate_number: certificateNumber,
        user_name: userName,
        blockchain_verified: true,
        verification_hash: verificationHash,
        blockchain_timestamp: new Date().toISOString(),
        smart_contract_id: '0x4a3b1dc76a44b4d62d5175d2ffae6a927978b3d1',
        issue_date: new Date().toISOString()
      })
      .select()
      .single();

    if (error) {
      console.error("Error creating sample certificate:", error);
      return { success: false, error };
    }
    
    return { success: true, data };
  } catch (error) {
    console.error("Unexpected error creating sample certificate:", error);
    return { success: false, error };
  }
};
